$( document ).ready(function() {
	$('.termtoggle').click(function() {
		let $this = $(this);
		if ($this.next().hasClass('show')) {
			$this.next().removeClass('show');
			$this.next().slideUp(350);
		}
		else {
			$this.parent().parent().find('li .inner').removeClass('show');
			$this.parent().parent().find('li .inner').slideUp(350);
			$this.next().toggleClass('show');
			$this.next().slideToggle(350);
		}
	});
	$('.js-slide.product-single__media-thumb').click(function() {
		$('.js-slide.product-single__media-thumb.active').addClass('active_no');
		$('.js-slide.product-single__media-thumb').removeClass('active_border');
		$(this).addClass('active_border');
	});
});  

var __fast_options = __fast_options || {};
__fast_options.serp_media_queries = [
	{device: 'mobile', query: '(max-width: 480px)'},
	{device: 'tablet', query: '(min-width: 481px) and (max-width: 1280px)'},
	{device: 'desktop', query: '(min-width: 1281px)'}
];  

